module.exports = __webpack_public_path__ + "images/goods-details-icon-share.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/goods-details-icon-share.png
// module id = 852
// module chunks = 121